'use client';

import { MarketId } from '@velocity-exchange/common';
import { useCurrentSlot } from 'src/hooks/useCurrentSlot';
import { useL2Orderbook } from 'src/hooks/query/orderbook/useL2Orderbook';
import { useMarketPriceState } from 'src/hooks/query/orderbook/useMarketPriceState';
import {
	useLiveOraclePrice,
	useLiveMmOracle,
} from 'src/stores/marketLiveState';

export const useTargetMarketSlotStaleness = (marketId: MarketId) => {
	const oracle = useLiveOraclePrice(marketId);
	const mmOracle = useLiveMmOracle(marketId);

	const { data: l2Orderbook } = useL2Orderbook(marketId);
	const { data: marketPriceStateData } = useMarketPriceState(marketId);

	const currentSlot = useCurrentSlot();

	const orderbookSlot = l2Orderbook?.slot;
	const marketSlot = marketPriceStateData?.slot ?? 0;

	const l2Slot = orderbookSlot ?? 0;
	const oracleSlot = oracle?.slot ?? 0;
	const mmOracleSlot = mmOracle?.slot ?? 0;

	return {
		l2SlotStaleness: currentSlot - l2Slot,
		oracleSlotStaleness: currentSlot - oracleSlot,
		marketSlotStaleness: currentSlot - marketSlot,
		mmOracleSlotStaleness: currentSlot - mmOracleSlot,
	};
};
